import { connect } from 'react-redux'
import ContactSubscribedDisplay from './ContactSubscribedDisplay'

const stateToProps = () => ({})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(ContactSubscribedDisplay)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactSubscribed/ContactSubscribedDisplay.container.js